import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';

import {systemOptionsTags} from 'helpers/dataHelpers';
import {chemicalBaseTypeNames} from 'helpers/constants';

import {Checkbox} from 'components/forms';
import {FormattedMessage} from 'react-intl';

let iconStyle = {marginLeft: 5, marginRight: 5, marginTop: 1, color: '#fff'};

export default function SystemSelectCard({customer, pool, onChange, disabled, formatMessage}) {
  let poolLocation = systemOptionsTags[pool.typeID].location;
  let poolFinish = systemOptionsTags[pool.typeID].finish;
  let flagged = pool.flag ? <i className='bl bl-flag-filled pull-right' style={iconStyle}/> : null;
  let sourceConcern = customer && customer.sourceConcern ? <i className='bl bl-water-pipe pull-right' style={iconStyle} /> : null;
  let chkbox;

  const none = `(${formatMessage({id: 'general.none'})})`;

  let prevAnalysisDate = pool.prevAnalysisDate ? moment(pool.prevAnalysisDate).format('ll') : formatMessage({id: 'general.none'});

  return <div className='pool pool-listing' style={{height: 100}} onClick={() => disabled === false && chkbox.onChange({value: !chkbox.getChecked()})}>
    <div className='customer-pool-header'>
      <Checkbox inline ref={c => chkbox = c} dataChanged={onChange} disabled={disabled} dataKey={pool.id.toString()} />
      {pool.softSoakTRIO ? 'Trio ' : null}
      {chemicalBaseTypeNames(pool.typeID, pool.sanitizerType || 2, formatMessage)}
      {sourceConcern}
      {flagged}
    </div>
    <div className='pool-details'>
      <p>
        {poolLocation[pool.location] ? formatMessage({id: poolLocation[pool.location]}) : none}
        <span className='separator'> | </span>
        {poolFinish[pool.finish] ? formatMessage({id: poolFinish[pool.finish]}) : none}
        <span className='separator'> | </span>
        {pool.volume.format(0, 3)} gals.
      </p>
      <p><FormattedMessage id='general.last.analysis' />: <span className='last-analysis-date b'>{prevAnalysisDate}</span></p>
    </div>
  </div>;
}
SystemSelectCard.propTypes = {
  customer: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  pool: PropTypes.object.isRequired,
  formatMessage: PropTypes.any,
};
